import PhotoSwipeLightbox from 'photoswipe/lightbox';
import PhotoSwipe from 'photoswipe';

const initProductLightbox = () => {
  const galleryEl = document.querySelector('[data-product-gallery-lightbox]');
  if (!galleryEl) return;

  const lightbox = new PhotoSwipeLightbox({
    gallery: '[data-product-gallery-lightbox]',
    children: 'a[data-lightbox-slide]',
    pswpModule: PhotoSwipe,
    bgOpacity: 1,
    padding: { top: 20, bottom: 20, left: 20, right: 20 },
    zoom: false,
    close: true,
    counter: true,
    arrowKeys: true,
  });

  lightbox.init();
};

export default initProductLightbox;
